import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 's1-input-text',
    templateUrl: './s1-input-text.component.html',
    styleUrls: ['./s1-input-text.component.scss'],
    standalone: false
})
export class S1InputText implements OnInit {

  @Input() control: UntypedFormControl;
  @Input() inputClass: string;
  @Input() label: string = '';
  @Input() labelGrouped: boolean = true;
  @Input() readonly: boolean = false;
  @Input() type: string = 'text';
  @Input() isValid: boolean = true;
  @Output() onChange = new EventEmitter<any>();

  @ViewChild('inputEl') inputEl: ElementRef;

  constructor() { }

  ngOnInit(): void { }

  checkIsValid(): boolean {
    return this.control && (this.control.valid || !this.control.touched);
  }

  getFocused() {

    setTimeout(()=> {
      this.inputEl?.nativeElement.focus();
    }, 1);
    
  }

  onInputChange(value) {
    this.onChange.emit(value);
  }

}
